import {
  AiOgAssist,
  BullseyeArrow,
  DeveloperPortal,
  Product311,
  ProductAppBuilder,
  ProductAssetManagement,
  ProductBp,
  ProductCommunityFeedback,
  ProductFinance,
  ProductOpenData,
  ProductPlc,
  ProductProcurement,
  ProductReportingTransparency,
  ProductTaxCollection,
  ProductUtilityBilling,
  ProductWorkflowBuilder
} from '@opengov/react-capital-assets';
import React from 'react';

import { DATA_TEST, getDynamicDataTestId } from '../../../enums';

// Define a type for the SVG components
type ReactSvgComponent = React.FC<React.SVGProps<SVGSVGElement>>;

const ProductIconSVGs: Record<string, ReactSvgComponent> = {
  'product-b&p': ProductBp,
  'product-eam': ProductAssetManagement,
  'product-r&t': ProductReportingTransparency,
  'product-cit': ProductPlc,
  'product-od': ProductOpenData,
  'product-pro': ProductProcurement,
  'product-fin': ProductFinance,
  'product-oth': ProductCommunityFeedback,
  'product-tax': ProductTaxCollection,
  'product-ub': ProductUtilityBilling,
  'product-gab': ProductAppBuilder,
  'product-agent-studio': AiOgAssist,
  'product-developer-portal': DeveloperPortal,
  'product-performance-management': BullseyeArrow,
  'product-wfb': ProductWorkflowBuilder,
  'product-311': Product311
};

export interface IProductIconProps {
  /** Label to be read by screen reader */
  ariaLabel?: string;
  /** Determines icon displayed, see possible values above. */
  icon: keyof typeof ProductIconSVGs;
  fill?: string;
}

export const ProductIcon: React.FC<IProductIconProps> = ({ ariaLabel, icon, fill }) => {
  const IconComponent = ProductIconSVGs[icon];

  if (!IconComponent) return null;

  return (
    <IconComponent
      aria-hidden={true}
      aria-label={ariaLabel} // Different format because icon file holds default
      data-test={getDynamicDataTestId(DATA_TEST.product_icon, icon)}
      focusable="false"
      fill={fill}
    />
  );
};
